<template>
  <div id="paginaPersonale">
    <!-- Elementi Pagina----------------------------------------------------------------------------------- -->
    <b-row class="match-height">

      <!-- Card Spreadsheet -->
      <b-col xl="12" md="12">
        <b-card tag="article" class="mb-2">
          <b-card-header class="align-items-baseline">
            <div>
              <b-card-title>Importazione Soggetti</b-card-title>
              <b-card-text class="mb-0">Reference</b-card-text>
            </div>
            <b-dropdown variant="link" no-caret right class="chart-dropdown" toggle-class="p-0">
              <template #button-content>
                <feather-icon icon="MoreVerticalIcon" size="18" class="text-body cursor-pointer" />
              </template>
              <b-dropdown-item href="#">
                ...
              </b-dropdown-item>
            </b-dropdown>
          </b-card-header>
          <b-card-body class="mb-0">
            <!-- card body -->
            <!-- Button:  -->
            <b-col xl="12" md="12" class="text-left mt-1">
              <ejs-button id="cambiaImmagineProfiloButton" @click.native="buttonSave()">Carica Righe</ejs-button>
            </b-col>
            <br/>
            <ejs-spreadsheet ref="spreadsheet" height=800 :created="created" :showRibbon="false" :showFormulaBar="false"
              :showSheetTabs="false">
              <e-sheets>
                <e-sheet>
                  <e-columns>
                    <e-column :width=130></e-column>
                    <e-column :width=130></e-column>
                    <e-column :width=130></e-column>
                    <e-column :width=130></e-column>
                    <e-column :width=130></e-column>
                    <e-column :width=130></e-column>
                    <e-column :width=130></e-column>
                    <e-column :width=130></e-column>
                    <e-column :width=130></e-column>
                    <e-column :width=180></e-column>
                    <e-column :width=130></e-column>
                    <e-column :width=130></e-column>
                  </e-columns>
                  <e-rows>
                    <e-row>
                      <e-cells>
                        <e-cell value="Cognome"></e-cell>
                        <e-cell value="Nome"></e-cell>
                        <e-cell value="Codice Fiscale"></e-cell>
                        <e-cell value="Partita IVA"></e-cell>
                        <e-cell value="Nato a"></e-cell>
                        <e-cell value="il"></e-cell>
                        <e-cell value="Cittadinanza"></e-cell>
                        <e-cell value="Via di Residenza"></e-cell>
                        <e-cell value="Cap di Residenza"></e-cell>
                        <e-cell value="Comune di Residenza"></e-cell>
                        <e-cell value="Stato di Residenza"></e-cell>
                        <e-cell value="IBAN"></e-cell>
                      </e-cells>
                    </e-row>
                  </e-rows>
                </e-sheet>
              </e-sheets>
            </ejs-spreadsheet>
          </b-card-body>
        </b-card>
      </b-col>



    </b-row>

  </div>
</template>
<script>
import Vue from "vue";
import useJwt from '@/auth/jwt/useJwt'
import { enableRipple } from '@syncfusion/ej2-base';
import { DateTimePickerPlugin, DateRangePickerPlugin, DatePickerPlugin, TimePickerPlugin } from "@syncfusion/ej2-vue-calendars";
import { ButtonPlugin, CheckBoxPlugin, SwitchPlugin } from "@syncfusion/ej2-vue-buttons";
import { TextBoxPlugin, NumericTextBoxPlugin, MaskedTextBoxPlugin, SliderPlugin, UploaderPlugin } from '@syncfusion/ej2-vue-inputs';
import { DropDownListPlugin, MultiSelectPlugin, ListBoxPlugin, CheckBoxSelection } from "@syncfusion/ej2-vue-dropdowns";
import { SpreadsheetPlugin } from '@syncfusion/ej2-vue-spreadsheet';
import { DialogPlugin } from '@syncfusion/ej2-vue-popups';
import { GridPlugin, Edit as GridEdit, Toolbar as GridToolbar, Sort as GridSort, Filter as GridFilter } from '@syncfusion/ej2-vue-grids';
import { DropDownButtonPlugin } from "@syncfusion/ej2-vue-splitbuttons";

import { LayoutPlugin, TabsPlugin, CardPlugin, DropdownPlugin, EmbedPlugin, TablePlugin, LinkPlugin, AlertPlugin, ProgressPlugin, ToastPlugin, FormGroupPlugin, FormInputPlugin, FormCheckboxPlugin, FormSelectPlugin } from 'bootstrap-vue'


Vue.use(TabsPlugin);
Vue.use(CardPlugin);
Vue.use(LayoutPlugin);
Vue.use(DropdownPlugin);
Vue.use(EmbedPlugin);
Vue.use(TablePlugin);
Vue.use(LinkPlugin);
Vue.use(AlertPlugin);
Vue.use(ProgressPlugin);
Vue.use(ToastPlugin);
Vue.use(FormGroupPlugin);
Vue.use(FormInputPlugin);
Vue.use(FormCheckboxPlugin);
Vue.use(FormSelectPlugin);

Vue.use(TextBoxPlugin);
Vue.use(NumericTextBoxPlugin);
Vue.use(MaskedTextBoxPlugin);
Vue.use(SliderPlugin);
Vue.use(UploaderPlugin);
Vue.use(DateRangePickerPlugin);
Vue.use(DatePickerPlugin);
Vue.use(DateTimePickerPlugin);
Vue.use(TimePickerPlugin);
Vue.use(DropDownListPlugin);
Vue.use(MultiSelectPlugin);
enableRipple(true);
Vue.use(ButtonPlugin);
Vue.use(CheckBoxPlugin);
Vue.use(SwitchPlugin);
Vue.use(SpreadsheetPlugin);
Vue.use(DialogPlugin);
Vue.use(GridPlugin);
Vue.use(DropDownButtonPlugin);
Vue.use(ListBoxPlugin);





export default Vue.extend({
  data: function () {
    return {
      id: 0,
      data: [],
    }
  },

  methods: {
    // per toast
    makeToast(variant = null, title = 'titolo', message = 'messaggio') {
      this.$bvToast.toast(message, {
        title,
        variant,
        solid: true,
        autoHideDelay: 5000,
      })
    },
    // per spreadsheet
    created: function () {
      this.$refs.spreadsheet.cellFormat({
        //fontWeight: 'bold',
        fontSize: '12pt',
        backgroundColor: '#99505f',
        textAlign: 'center',
        color: '#ffffff',
        borderBottom: '1px solid #e0e0e0'
      }, 'A1:AE1')
      // proteggere da scrittura la prima riga <---------TODO--------------------------
      let protectSetting = {
            selectCells: true,
            formatCells: false,
            formatRows: false,
            formatColumns: false,
            insertLink: false
        };
      this.$refs.spreadsheet.protectSheet("Issues", protectSetting);
      this.$refs.spreadsheet.lockCells('A1:AE1', true); // to lock the cells
      this.$refs.spreadsheet.lockCells('A2:AE1000', false);
      // posizionare cursore in seconda riga prima colonna <---------TODO--------------------------
      this.$refs.spreadsheet.goTo("A2"); // pass the range
    },
    buttonSave() {
      this.$refs.spreadsheet.saveAsJson().then(jsonData => {
        useJwt.post('/demo/api/soggetto/importa', jsonData)
      }).then(data => console.log(data))
      this.makeToast('primary', 'Info', 'Import eseguito (inserire feedback sulla riuscita operazione)')
      // gestire feedback <---------TODO--------------------------
      // se riuscito, svuotare spreadsheet e posizionare cursore in seconda riga prima colonna <---------TODO--------------------------
      this.$refs.spreadsheet.clear({type: 'Clear Contents', range: 'A2:Z10'}); // Clear the content in the provided range
      this.$refs.spreadsheet.goTo("A2"); // pass the range
    },


  }
});
</script>

<style lang="scss" >
@import "~@syncfusion/ej2-base/styles/material.css";
@import "~@syncfusion/ej2-buttons/styles/material.css";
@import "~@syncfusion/ej2-vue-buttons/styles/material.css";
@import '~@syncfusion/ej2-dropdowns/styles/material.css';
@import "~@syncfusion/ej2-vue-popups/styles/material.css";
@import "~@syncfusion/ej2-vue-navigations/styles/material.css";
@import '~@syncfusion/ej2-inputs/styles/material.css';
@import '~@syncfusion/ej2-vue-layouts/styles/material.css';
@import '~@syncfusion/ej2-splitbuttons/styles/material.css';
@import '~@syncfusion/ej2-grids/styles/material.css';
@import "~@syncfusion/ej2-vue-spreadsheet/styles/material.css";
@import '~@syncfusion/ej2-navigations/styles/material.css';
@import '~@syncfusion/ej2-popups/styles/material.css';
</style>